import { ReactNode, useCallback } from 'react';

export interface StatsGridItem {
  id: string;
  name: string | ReactNode;
  change?: string;
  changeType?: 'positive' | 'negative';
  value: string | ReactNode;
  secondaryValue?: string | ReactNode;
}

interface Props {
  stats: StatsGridItem[];
  className?: string;
}

function classNames(...classes: (string | boolean | undefined)[]) {
  return classes.filter(Boolean).join(' ');
}

export default function DynamicStats({ stats, className = '' }: Props) {
  const filterStats = useCallback(() => {
    return stats.filter(
      (stat) =>
        !['Active Variants', 'Page Speed Score'].includes(stat.name as string),
    );
  }, [stats]);

  return (
    <dl
      className={classNames(
        'mx-auto flex w-full flex-row gap-2 sm:gap-6',
        className,
      )}
    >
      {filterStats().map((stat) => (
        <div
          key={stat.id}
          className={classNames(
            'flex min-w-44 flex-1 flex-shrink-0 flex-wrap items-baseline justify-between gap-x-4 gap-y-2 rounded-md border border-[#D8DEE3] bg-gray-50 px-4 py-6 sm:min-w-36 sm:px-6 xl:px-8',
          )}
        >
          <div className="flex w-full flex-row items-center justify-between gap-2">
            <dt className="text-sm/6 font-medium text-gray-500">{stat.name}</dt>
            {!!stat.change && (
              <dd
                className={classNames(
                  stat.changeType === 'negative'
                    ? 'text-rose-600'
                    : 'text-gray-700',
                  'text-xs font-medium',
                )}
              >
                {stat.change ?? '0.00%'}
              </dd>
            )}
          </div>
          <dd className="w-full flex-none text-3xl/10 font-medium tracking-tight text-gray-900">
            {stat.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
